import { CartOccEndpoints } from '@spartacus/cart/base/occ';
import { OccConfig } from '@spartacus/core';
import { OrderOccEndpoints } from '@spartacus/order/occ';
import { UserAccountOccEndpoints } from '@spartacus/user/account/occ';
import { UserProfileOccEndpoints } from '@spartacus/user/profile/occ';

const defaultB2bUserAccountOccEndpoints: UserAccountOccEndpoints = {
  user: 'b2bUsers/${userId}',
};

const defaultB2bUserProfileOccEndpoints: UserProfileOccEndpoints = {
  userUpdateProfile: 'users/${userId}',
  userCloseAccount: 'users/${userId}',
};

// only change is in addEntries
const customB2bCartOccEndpoints: CartOccEndpoints = {
  addEntries: 'b2bUsers/current/carts/${cartId}/entries', // no quantity? -> not needed
};
const customB2bOrderOccEndpoints: OrderOccEndpoints = {
  placeOrder: 'b2bUsers/${userId}/orders?fields=FULL',
  scheduleReplenishmentOrder:
    'b2bUsers/${userId}/replenishmentOrders?fields=FULL,costCenter(FULL),purchaseOrderNumber,paymentType',
  reorder: 'b2bUsers/${userId}/cartFromOrder?orderCode=${orderCode}',
};

export const customB2bOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        ...defaultB2bUserAccountOccEndpoints,
        ...defaultB2bUserProfileOccEndpoints,
        ...customB2bCartOccEndpoints,
        ...customB2bOrderOccEndpoints,
      },
    },
  },
};
